import { useState } from 'react'
import { useDebounce } from 'use-debounce'
import * as INPUTS from '../config/inputs'
import { INPUT_DEBOUNCE_RATE } from '../config/static'

export const useDate = (slug, defaultOptions = {}) => {
  const { default: defaultValue, description, label } = INPUTS[slug]
  const [value, setValue] = useState(defaultOptions.value ?? defaultValue)
  const [date, setDate] = useState(null)
  const [debouncedValue] = useDebounce(date, INPUT_DEBOUNCE_RATE)

  const handleChange = (value, date) => {
    if (date) {
      setDate(date)
    }

    setValue(value)
  }

  const props = {
    description,
    inputDateProps: {
      onChange: handleChange,
      value,
    },
    title: label,
  }

  return { inputType: 'input', props, value: date, debouncedValue }
}
